import React, { ReactElement, ReactNode } from "react";
import ValidateUserAndPresentLogon from "features/Header/PuzzelTelephone/components/ValidateUserAndPresentLogon";
import { UserValidationProvider } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { PuzzelAuthenticationProvider } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";

type Props = {
  children: ReactNode;
};

export const PuzzelProvider = ({ children }: Props): ReactElement | null => (
  <PuzzelAuthenticationProvider>
    <UserValidationProvider>
      <ValidateUserAndPresentLogon>{children}</ValidateUserAndPresentLogon>
    </UserValidationProvider>
  </PuzzelAuthenticationProvider>
);
